import React from 'react';
import { Avatar, Dropdown, MenuProps, message } from 'antd';
import { UserOutlined, LogoutOutlined, LockOutlined } from '@ant-design/icons';
import { config } from '@/config';
import { get } from 'lodash';
import { useAppContext } from '@/core';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const DropdownMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userData } = useAppContext();

  const userName = get(userData, 'username') || get(userData, 'email') || 'User';
  const userInitial = userName.charAt(0).toUpperCase();

  const handleLogout = (): void => {
    try {
      const currentUrl = window.location.href;
      window.location.href = `${config.base.webUrl}/logout?callbackUrl=${currentUrl}`;
    } catch (error) {
      message.error('Logout failed. Please try again.');
      console.error('Logout error:', error);
    }
  };

  const handleProfileClick = (): void => {
    navigate('/me');
  };

  const handleChangePasswordClick = (): void => {
    navigate('/change-password');
  };

  const menuItems: MenuProps['items'] = [
    {
      key: 'profile',
      label: t('common.profile'),
      icon: <UserOutlined />,
      onClick: handleProfileClick,
    },
    {
      key: 'change-password',
      label: t('common.changePassword'),
      icon: <LockOutlined />,
      onClick: handleChangePasswordClick,
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: t('common.logOut'),
      icon: <LogoutOutlined />,
      onClick: handleLogout,
      danger: true,
    },
  ];

  return (
    <Dropdown
      menu={{ items: menuItems }}
      placement='bottomRight'
      trigger={['click']}
      overlayClassName='headerDropdown'
      overlayStyle={{ minWidth: '180px' }}
    >
      <div className='flex items-center gap-2 px-4 py-2 rounded-lg cursor-pointer hover:bg-gray-100 transition ml-auto my-[10px]'>
        <Avatar size='small' icon={<UserOutlined />} style={{ backgroundColor: '#1890ff' }}>
          {userInitial}
        </Avatar>
        <div className='flex flex-col'>
          <span className='text-sm font-medium text-gray-700'>{userName}</span>
          <span className='text-xs text-gray-500'>{userData?.email || '-'}</span>
        </div>
      </div>
    </Dropdown>
  );
};
